import React from 'react';

import { AttentionMessage } from '@eika/attention-message';
import { Button } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Modal } from '@eika/modal';

import useText from '@hooks/use-text';

import './OnlyNativeAllowedWarning.scss';

export const OnlyNativeAllowedWarning = ({ onClose }: { onClose(): void }) => {
    const { digitalCardTitle, digitalCardOnlyNativeWarning, formOk } = useText();

    return (
        <Modal
            title={digitalCardTitle}
            open
            setOpen={onClose}
            footerContent={
                <div className="only-native-allowed-warning-button">
                    <Button onClick={onClose}>{formOk}</Button>
                </div>
            }
        >
            <AttentionMessage
                type="info"
                id="google-pay-low-assurance"
                text={digitalCardOnlyNativeWarning}
                icon={IconTypes.INFO_24}
            />
        </Modal>
    );
};
